import { useState } from 'react'
import type { InputHTMLAttributes } from 'react'
import { useTar } from '@/modules'

interface PasswordInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
    hasError?: boolean
}

export const PasswordInput = ({ hasError = false, disabled, className, ...rest }: PasswordInputProps) => {
    const [showPassword, setShowPassword] = useState(false)
    const { t } = useTar()

    const baseClasses = `w-full pr-10 pl-3 py-2 border rounded-lg bg-background text-foreground
                       placeholder-muted focus:outline-none focus:ring-2 focus:ring-ring 
                       focus:border-accent transition-colors`

    const errorOrBorder = hasError ? 'border-error' : 'border-border'
    const disabledClasses = disabled ? 'opacity-50 cursor-not-allowed' : ''

    return (
        <div className="relative">
            <input
                type={showPassword ? 'text' : 'password'}
                disabled={disabled}
                className={`${baseClasses} ${errorOrBorder} ${disabledClasses} ${className ?? ''}`}
                {...rest}
            />
            <button
                type="button"
                aria-label={showPassword ? t('common.hidePassword') : t('common.showPassword')}
                title={showPassword ? t('common.hidePassword') : t('common.showPassword')}
                onClick={() => setShowPassword((v) => !v)}
                disabled={disabled}
                className={`absolute inset-y-0 right-0 px-3 flex items-center text-muted-foreground transition-colors
          ${disabled ? 'cursor-not-allowed opacity-50' : 'hover:text-foreground'}`}
            >
                {showPassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-5 0-9.27-3.11-11-8 1-2.73 2.77-4.99 5-6.41" />
                        <path d="M1 1l22 22" />
                        <path d="M9.88 9.88A3 3 0 0 0 12 15a3 3 0 0 0 2.12-.88" />
                        <path d="M14.12 14.12 9.88 9.88" />
                        <path d="M10.73 5.08A10.94 10.94 0 0 1 12 4c5 0 9.27 3.11 11 8-.51 1.4-1.24 2.68-2.15 3.79" />
                    </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                )}
            </button>
        </div>
    )
}


